export enum ROUTE_NAME {
  ROOT = "",
  LOGIN = "login",
  RESET_PASSWORD = "reset-password",
  RECOVER_USERNAME = "recover-username",
  VERIFY_IDENTITY = "verify-identity",
  VERIFY_OTP = "verify-otp",
  SET_ACCOUNT_PASSWORD = "set-password",
  ACCOUNT_PASSWORD_UPDATE = "update-password",
  CHANGE_PASSWORD = "change-password",
  TENANT_MANAGEMENT = "tenant-management",
  TENANT = "tenant",
  TENANT_SETTINGS = "tenant/:tenantId?",
  NOT_FOUND = "404",
  HOSPITAL = "hospital",
  HOSPITAL_SETTINGS = "hospital/:hospitalId?",
  SPECIALITY_MILESTONES = "speciality/:specialityId/milestones",
  USER = "user",
  USER_SETTINGS = "user/:userId?",
  USER_ACCOUNT = "user-account",
  ROOM = "room",
  ROOM_SETTINGS = "room/:roomId?",
  SUPPORT = "support",
  DASHBOARD = "dashboard",
  ALERTS = "alerts",
  CASE_MANAGEMENT = "case-management",
  CASE_BOARD = "case-board",
  CASE_DETAIL = "case-management/:caseId?",
  CODING="coding",
  CODING_RECOMMENDATION="coding-recommendation",
  CODING_CASE_DETAIL="coding-case-detail",
  PREDICTION="prediction",
}
